import React from "react";

const NavBar = () => {
  return (
    <>
      <div className="main-nav">
        <ul style={{ display: "flex", gap:'2.5rem', listStyles:'none'}}>
          <li>Home</li>
          <li>About</li>
          <li>Developers</li>
          <li>Bookings</li>
        </ul>
      </div>
    </>
  );
};

export default NavBar;
